import React, {useState} from "react";
import {Typography, Box, CircularProgress, FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import useDriver from "../hooks/useDriver";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component";
import CustomDialog from "../../../core/components/ui/CustomDialog";

const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedAction} = props;

    const {loading, updateDriverStatus} = useDriver();

    
    const [selectedStatus, setSelectedStatus] = useState(null);


    const handleStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);

        console.log('selected status', value)
    }


    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const parameters = {
            deviceId: selectedAction.device_id,       
            status: selectedStatus ? selectedStatus : selectedAction.status,
            profile_uid: selectedAction.profile_uid,
        }

        updateDriverStatus(parameters, setOpen)

    }

    const actions = [
        {
            label: "Update",
            onClick: (e) => 
                (selectedStatus) ? handleUpdateStatus(e) : null
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={ handleClose}
                title={<Typography sx={{fontWeight: 500}}>Update Status</Typography>}
                hasDividers={true}
                content={
                    <Box>
                        {(loading) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating status..."}
                                />
                            </Box>
                        : 
                            <>
                                <Typography sx={{mb: (selectedStatus) ? 1 : 1, fontWeight: 600, fontSize: 15}}>
                                    Status
                                </Typography>

                                <FormControl fullWidth >
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={selectedAction?.status}
                                        onChange={handleStatusChange}
                                    >
                                        <MenuItem value="Active">Active</MenuItem>
                                        <MenuItem value="Active">Deactivated</MenuItem>
                                        <MenuItem value="Suspended">Suspended</MenuItem>
                                    </Select>
                                    
                                   
                                </FormControl>
                            </>
                        } 
                    </Box>
                }
                actions={!loading && actions}
                maxWidth={"sm"}
                customStyles={{
                    actions: {
                        opacity: (selectedStatus && !loading) ? "100%" : "55%",
                        cursor: (selectedStatus && !loading) ? "pointer" : "not-allowed !important",
                        visibility: (loading) ? "hidden" : "visible",
                    }
                }}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
